import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotifications, resetNotification } from "../../store/actions";
import { ThreeDots } from "react-loader-spinner";

const auctionCenterIdFromURI = window.location.pathname?.split("/")[4]
  ? atob(window.location.pathname.split("/")[4])
  : "";

const auctionTypeFromURL = window.location.pathname?.split("/")[1]

const userId = auctionTypeFromURL === "auctionPage"
  ? atob(localStorage.getItem("argument2"))
  : window.location.pathname?.split("/")[3]
    ? atob(window.location.pathname.split("/")[3])
    : "";
console.log("auctionuserId", userId)

const userRoleCode = atob(localStorage.getItem("argument6"));

const ViewNotification = ({ modalRight, open, setOpen }) => {
  const dispatch = useDispatch();

  // Notification types mapped to API params
  const radioButtonData = [
    { key: "Bids & Deals Message", value: "1" },
    { key: "Admin Messages ", value: "0" },
    { key: "System Messages ", value: "2" },
  ];

  const [selectedNotification, setSelectedNotification] = useState("1"); // Default selection
  const [showData, setShowData] = useState(false);

  // Fetch notifications from Redux store
  const ViewNotification = useSelector(
    (state) => state?.viewNotification?.notifications?.responseData
  );
  console.log(ViewNotification, "ViewNotification");

  // Fetch notifications when the selected type changes
  const handleRadioChange = (event) => {
    dispatch(resetNotification())
    setSelectedNotification(event.target.value);
    setShowData(false); // Hide data until "Search" is clicked
  };

  const handleSearch = () => {
    const updatedUserId = selectedNotification === "2" ? "0" : userId;
    dispatch(
      fetchNotifications(
        auctionCenterIdFromURI,
        updatedUserId,
        selectedNotification,
        auctionTypeFromURL 
      )
    );

    setShowData(true); // Show data when search is clicked
  };

  const handleClear = () => {
    setSelectedNotification("1");
    setShowData(false);
    // Reset but don't fetch data
  };
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="row align-items-end">
            <div className="col-md-4">
              <div class="col-md-auto d-flex CheckboxGroup mb-12 mr-4">
                {/* <h6>Search the notification</h6> */}
                {radioButtonData.map((data, index) => (
                  <div className="form-check mr-4" key={index}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="notificationType"
                      id={data.key}
                      value={data.value}
                      checked={selectedNotification === data.value}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" htmlFor={data.key}>
                      {data.key}
                    </label>
                    &nbsp;&nbsp;
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="BtnGroup">
              <button className="SubmitBtn" onClick={handleSearch}>
                Search
              </button>
              <button className="Clear" onClick={handleClear}>
                Clear
              </button>
            </div>
          </div>

          <table id="example" class="stripe- row-border order-column table ">
            <thead>
              <tr>
                {userRoleCode == "AUCTIONEER" ||
                  userRoleCode == "ASSOCIATEAUCTIONEER" ||
                  userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                  userRoleCode == "BUYER" ||
                  userRoleCode == "ASSOCIATEBUYER" ||
                  userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
                  userRoleCode == "SELLER" ? (
                  <>
                    <th>Auction Center</th>
                    <th>Date & Time of Notification</th>
                    <th>Message / Notification</th>
                  </>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            {showData &&
              ViewNotification &&
              Array.isArray(ViewNotification) &&
              ViewNotification.length > 0 ? (
              ViewNotification?.map((col, index) => (
                <tr key={index}>
                  {userRoleCode == "AUCTIONEER" ||
                    userRoleCode == "ASSOCIATEAUCTIONEER" ||
                    userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
                    userRoleCode == "BUYER" ||
                    userRoleCode == "ASSOCIATEBUYER" ||
                    userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
                    userRoleCode == "SELLER" ? (
                    <>
                      <td>{col.auctionCenter}</td>
                      <td>{col.dateandTimeofNotification}</td>
                      <td>{col.notification}</td>
                    </>
                  ) : null}
                </tr>
              ))
            ) : (
              <td colSpan={35}>
                <div className="NoData">No record found</div>
              </td>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default ViewNotification;
